export default class SpecificationInput {
  gain;
  gainUnit;
  passbandAttenuation;
  stopbandAttenuation;
  filterResponseValue;
  selectedResponseType;
  passbandFrequency;
  stopbandFrequency;
  centerFrequency;
  filterResponseSlider;

  constructor(args) {
    if (args) {
      this.gain = args.gain ?? null;
      this.gainUnit = args.gainUnit ?? null;
      this.passbandAttenuation = args.passbandAttenuation ?? null;
      this.stopbandAttenuation = args.stopbandAttenuation ?? null;
      this.filterResponseValue = args.filterResponseValue ?? null;
      this.selectedResponseType = args.selectedResponseType ?? null;
      this.passbandFrequency = args.passbandFrequency ?? null;
      this.stopbandFrequency = args.stopbandFrequency ?? null;
      this.centerFrequency = args.centerFrequency;
      this.filterResponseSlider = args.filterResponseSlider ?? null;
    }
  }
}
